// Tiny store to share the current branch with non-React layers (e.g., i18n)
// This avoids relying on React context where it is not available (outside <Refine> tree).
import type { Branch } from "types/branch";

let currentBranch: Branch | null = null;

export const setCurrentBranch = (b: Branch | null) => {
  currentBranch = b;
};

export const getCurrentBranch = (): Branch | null => currentBranch;
